import React, { useState } from 'react';
import './styles/Dashboard.css';
import { FaChevronRight, FaGlobe, FaHotel, FaNewspaper, FaUtensils, FaHiking, FaCalendar } from 'react-icons/fa';
import { Link, Outlet, useLocation } from 'react-router-dom';

export default function Dashboard() {
    const [menu, setMenu] = useState([
        {
            name: 'Management',
            type: 'header'
        },
        {
            id: 1,
            name: "Countries",
            type: 'option',
            ref: 'countries',
            icon: <FaGlobe />
        },
        {
            id: 2,
            name: "Hotels",
            type: 'option',
            ref: 'hotels',
            icon: <FaHotel />
        },
        {
            id: 4,
            name: "Restaurants",
            type: 'option',
            ref: 'restaurants',
            icon: <FaUtensils />
        },
        {
            id: 5,
            name: "Experiences",
            type: 'option',
            ref: 'experiences',
            icon: <FaHiking />
        },
        {
            id: 6,
            name: "Events",
            type: 'option',
            ref: 'events',
            icon: <FaCalendar />
        },
        {
            id: 3,
            name: "Articles",
            type: 'option',
            ref: 'articles',
            icon: <FaNewspaper />
        }
    ]);

    const [account, setAccount] = useState({
        first_name: 'Admin',
        last_name: 'User',
        role: 'Administrator'
    });
    
    const [selectedOption, setSelectedOption] = useState(1);
    const location = useLocation();

    // Update selected option based on current path
    React.useEffect(() => {
        const path = location.pathname.split('/').pop();
        const menuItem = menu.find(item => item.type === 'option' && item.ref === path);
        if (menuItem) {
            setSelectedOption(menuItem.id);
        }
    }, [location.pathname, menu]);

    const Sidebar = () => {
        const render_options = menu.map((item, index) => {
            if(item.type === 'header'){
                return (
                    <div className='SidebarHeader' key={`header-${index}`}>{item.name}</div>
                );
            }

            return (
                <Link 
                    to={item.ref} 
                    className={`SidebarOption ${(selectedOption === item.id) ? 'Active' : ''}`} 
                    key={`option-${item.id}`}
                    onClick={() => {
                        setSelectedOption(item.id);
                    }}
                >
                    <div className='SidebarOptionIcon'>
                        {item.icon}
                    </div>
                    <div className={`SidebarOptionText ${(selectedOption === item.id) ? 'Active' : ''}`}>
                        {item.name}
                    </div>
                    <FaChevronRight 
                        size={12} 
                        color={(selectedOption === item.id) ? '#1976d2' : '#fff'} 
                    />
                </Link>
            );
        });

        return (
            <div className='Sidebar'>
                <div className='SidebarAccount'>
                    <div className='SidebarAccountAvatar'></div>
                    <div className='SidebarAccountInfo'>
                        <div className='SidebarAccountInfoTitle'>
                            {account.first_name + ' ' + account.last_name}
                        </div>
                        <div className='SidebarAccountInfoSub'>{account.role}</div>
                    </div>
                </div>

                <div className='SidebarHeader' style={{color: '#fff'}}>Options</div>
                <div className='SidebarOptions'>
                    {render_options}
                </div>
            </div>
        );
    };

    return (
        <div className='Dashboard'>
            <Sidebar />
            <div className='DashboardContent'>
                <Outlet />
            </div>
        </div>
    );
}
